import { useMediaQuery } from '@vueuse/core'

import type { Ref } from 'vue'

// Mirrors the media_min_w_500 / media_min_h_500 mixins (app/assets/scss/_mixins.scss).
// Both axes: width alone passes a phone in landscape, where screen sharing doesn't work.
const DESKTOP_VIEWPORT_QUERY = '(min-width: 500px) and (min-height: 500px)'

export const useDesktopViewport = (): Ref<boolean> => useMediaQuery(DESKTOP_VIEWPORT_QUERY)
